import React from "react";
import PropTypes from "prop-types";
import Table from "../../../common/components/Table/Table";
import {Link} from "react-router-dom";
import _ from "lodash";

const sourceTypeOptions = require("../../../common/resources/sourcetypes.json")

export default class AssociatedServicesAndSourcesTable extends React.Component {

    static propTypes = {
        associatedKYCData: PropTypes.array,
        associatedKYBData: PropTypes.array,
    }

    render() {

        const {associatedKYCData, associatedKYBData} = this.props;

        const tableHeaders = [
            <Table.Header key="source">Data Source</Table.Header>,
            <Table.Header key="service">DP Service</Table.Header>,
            <Table.Header key="provider">Data Provider</Table.Header>,
        ];

        return(
            <div className="associated-services-sources-providers-table">
                <h2>{"Associated Data Sources, Services And Providers"}</h2>
                {associatedKYCData.length > 0
                    ? (
                        <div>
                            <h3>{"KYC"}</h3>
                            <div className="associated-data-sticky-table-container">
                                <Table
                                    className="sticky-table"
                                    headers={tableHeaders}
                                >
                                    {associatedKYCData.map((s, idx) => {
                                        const serviceID = s.service_id;
                                        const sourceID = s.source_id;
                                        const providerID = s.provider_id;

                                        const sourceType = _.result(_.find(sourceTypeOptions, {
                                            value: s.source_type
                                        }), "label") + " " + s.source_type_identifier

                                        return (
                                            <tr key={idx}>
                                                <td>
                                                    <Link to={{pathname: `/veritas/data-source/kyc/` + sourceID}}
                                                          key={sourceID}
                                                    >
                                                        <span>{sourceType}</span>
                                                    </Link>
                                                        <p>{s.status}</p>
                                                </td>
                                                <td>
                                                    <Link to={{pathname: `/veritas/kyc-services/` + serviceID}}
                                                          key={serviceID}
                                                    >
                                                        <span>{s.service_name}</span>
                                                    </Link>
                                                    <p>{"Primary Service Config Name: "} {s.Name}</p>
                                                </td>
                                                <td>
                                                    <Link to={{pathname: `/veritas/data-providers/` + providerID}}
                                                          key={providerID}
                                                    >
                                                        <span>{s.provider_name}</span>
                                                    </Link>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </Table>
                            </div>
                            <br/>
                        </div>
                    )
                    : null }
                {associatedKYBData.length > 0
                    ? (
                        <div>
                            <h3>{"KYB"}</h3>
                            <div className="associated-data-sticky-table-container">
                                <Table
                                    className="sticky-table"
                                    headers={tableHeaders}
                                >
                                    {associatedKYBData.map((s, idx) => {
                                        const serviceID = s.service_id;
                                        const sourceID = s.source_id;
                                        const providerID = s.provider_id;

                                        const sourceType = _.result(_.find(sourceTypeOptions, {
                                            value: s.source_type
                                        }), "label") + " " + s.source_type_identifier

                                        return (
                                            <tr key={idx}>
                                                <td>
                                                    <Link to={{pathname: `/veritas/data-source/kyb/` + sourceID}}
                                                          key={sourceID}
                                                    >
                                                        <span>{sourceType}</span>
                                                    </Link>
                                                    <p>{s.status}</p>
                                                </td>
                                                <td>
                                                    <Link to={{pathname: `/veritas/kyb-services/` + serviceID}}
                                                          key={serviceID}
                                                    >
                                                        <span>{s.service_name}</span>
                                                    </Link>
                                                    <p>{"Primary Service Config Name: "} {s.Name}</p>
                                                </td>
                                                <td>
                                                    <Link to={{pathname: `/veritas/data-providers/` + providerID}}
                                                          key={providerID}
                                                    >
                                                        <span>{s.provider_name}</span>
                                                    </Link>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </Table>
                            </div>
                        </div>
                    )
                    : null }
            </div>
        );
    }

}
